<template>
  <div>
    <v-row dense>
      <v-col cols="2">
        <input_decimal label="" prefix="%" :amount="wizardData.margin_quantity" field="margin_quantity" @updateData="updateData"/>
      </v-col>
    </v-row>
  </div>      
</template>

<script>

  import input_decimal from '@/components/huis/hspt/ui/input_amount.vue';

  export default {
    props: {
      wizardData: Object
    },
    components: {
      input_decimal,
    },
    methods:{
      updateData(data){
        this.$emit('updateData', data);
      },
    },    
  }
</script>

<style scoped>
</style>